import { useSelector } from "react-redux";
import { 
  AtoZText, 
  highPriceText, 
  lowPriceText, 
  popularityText, 
  relevanceText, 
  ZtoAText 
} from "../store/orderingSlice";

export function SortSelect({sortBy,onChange,sortableByPrice = false}) {
  const relevance_text = useSelector(relevanceText);
  const popularity_text = useSelector(popularityText);
  const lowprice_text = useSelector(lowPriceText);
  const highprice_text = useSelector(highPriceText);
  const atoz_text = useSelector(AtoZText);
  const ztoa_text = useSelector(ZtoAText);

  return (
    <select
      className="color-drawer__sort-select"
      onChange={onChange}
      value={sortBy}
    >
      <option value="relevance">{relevance_text}</option>
      <option value="popular">{popularity_text}</option>
      {sortableByPrice && <>
          <option value="low_price">{lowprice_text}</option>
          <option value="high_price">{highprice_text}</option>      
        </>
      }
      <option value="a_to_z">{atoz_text}</option>
      <option value="z_to_a">{ztoa_text}</option>
    </select>
  );
}
